import { render } from "./AppPostPagination.html?vue&type=template&id=5a24e817"
import script from "./AppPostPagination.js?vue&type=script&lang=js"
export * from "./AppPostPagination.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__